import styled from 'styled-components';
import { COLORS, BREAKPOINTS } from '../style';

type ButtonColor = 'white' | 'blue' | 'green' | 'wpp';

const StyledButton = styled.a<{ $color: ButtonColor }>`
  display: block;
  padding: 16px 64px;
  width: 100%;
  border-radius: 30px;
  background: ${({ $color }) => COLORS[$color]};
  border: 2px solid ${({ $color }) => COLORS[$color]};
  color: ${({ $color }) => ($color === 'white' ? COLORS.blue : COLORS.white)};
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  text-decoration: none;

  &:hover {
    background: transparent;
    color: ${({ $color }) => COLORS[$color]};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 16px 0;
  }
`;

interface ButtonProps extends React.ComponentProps<'a'> {
  children: React.ReactNode;
  color: ButtonColor;
  href?: string;
}

const Button = ({ children, color, href, ...props }: ButtonProps) => {
  return (
    <StyledButton $color={color} href={href} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;
